import { render } from "./DisciplineImageView.vue?vue&type=template&id=02cf28b0&scoped=true"
import script from "./DisciplineImageView.vue?vue&type=script&lang=js"
export * from "./DisciplineImageView.vue?vue&type=script&lang=js"

import "./DisciplineImageView.vue?vue&type=style&index=0&id=02cf28b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02cf28b0"]])

export default __exports__